import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {GlobalProvider} from "../../providers/global/global";

/**
 * Generated class for the VorlageneditorMasterdataDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vorlageneditor-masterdata-details',
  templateUrl: 'vorlageneditor-masterdata-details.html',
})
export class VorlageneditorMasterdataDetailsPage {

  public types: Array<{ name: string, value: string }> = [
    {name: "Text", value: "text"},
    {name: "Datum", value: "date"},
    {name: "Zahl", value: "number"}
  ];

  public data: any = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController, public globalProvider: GlobalProvider) {
    console.log('test');
    this.data = this.navParams.get('masterData');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VorlageneditorMasterdataDetailsPage');
  }

  public deleteListEntry(item): void {
    this.data.list = this.data.list.filter((_item) => {
      return _item.propertyName !== item.propertyName;
    })
  }

  public addNewEntry(): void {
    this.data.list.push({propertyName: Date.now(), title: ''});
    let lastItem = this.data.list[this.data.list.length - 1];

    setTimeout(() => {
      document.getElementById(lastItem.propertyName).getElementsByTagName('input')[0].focus();
    }, 0);
  }

  public sort(): void {
    this.data.list = this.data.list.sort(function (a, b) {
      if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
      if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
      return 0;
    })
  }

  public onKeyPressed(event): void {
    if (this.data.list.length > 0 && this.data.list[this.data.list.length - 1].title.length > 0) {
      event.preventDefault();
      this.addNewEntry();
    }
  }

  public close(): void {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/vorlageneditor-masterdata-details/vorlageneditor-masterdata-details.ts